import clear_sky_d from './clear_sky_d.png';
import clear_sky_n from './clear_sky_n.png';
import few_clouds_d from './few_clouds_d.png';
import few_clouds_n from './few_clouds_n.png';
import scattered_clouds from './scattered_clouds.png';
import broken_clouds from './broken_clouds.png';
import shower_rain from './shower_rain.png';
import rain_d from './rain_d.png';
import rain_n from './rain_n.png';
import thunderstorm from './thunderstorm.png';
import snow from './snow.png';
import mist from './mist.png';

export const weatherConditionImages = {
  '01d': clear_sky_d,
  '01n': clear_sky_n,
  '02d': few_clouds_d,
  '02n': few_clouds_n,
  '03d': scattered_clouds,
  '03n': scattered_clouds,
  '04d': broken_clouds,
  '04n': broken_clouds,
  '09d': shower_rain,
  '09n': shower_rain,
  '10d': rain_d,
  '10n': rain_n,
  '11d': thunderstorm,
  '11n': thunderstorm,
  '13d': snow,
  '13n': snow,
  '50d': mist,
  '50n': mist,
};
